// /app/Providers.tsx
'use client'
import {
  isServer,
  QueryClient,
  QueryClientProvider
} from '@tanstack/react-query'

function makeQueryClient (): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000
      }
    }
  })
}
let browserQueryClient: QueryClient | undefined
function getQueryClient (): QueryClient {
  if (isServer) {
    // Server: always make a new query client
    return makeQueryClient()
  } else {
    // Browser: make a new query client if we don't already have one
    // This is very important, so we don't re-make a new client if React
    // suspends during the initial render. This may not be needed if we
    // have a suspense boundary BELOW the creation of the query client
    if (browserQueryClient == null) browserQueryClient = makeQueryClient()
    return browserQueryClient
  }
}
export default function QueryProviders ({ children }: Readonly<{ children: React.ReactNode }>): JSX.Element {
  const queryClient = getQueryClient()
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
